export const MOBILE_BREAKPOINT_N = 900
export const MOBILE_BREAKPOINT = `${MOBILE_BREAKPOINT_N}px`
export const MOBILE_STYLE = `@media (max-width: ${MOBILE_BREAKPOINT})`

export const TABLET_BREAKPOINT_N = 1200
export const TABLET_BREAKPOINT = `${TABLET_BREAKPOINT_N}px`
export const TABLET_STYLE = `@media (min-width: ${MOBILE_BREAKPOINT}) and (max-width: ${TABLET_BREAKPOINT})`

export const DESKTOP_STYLE = `@media (min-width: ${TABLET_BREAKPOINT})`
